import { z } from 'zod'

const optionalString = z.preprocess(
	value => (value === '' ? undefined : value),
	z.string().min(1).optional(),
)

const optionalUrl = z.preprocess(
	value => (value === '' ? undefined : value),
	z.string().url().optional(),
)

const schema = z.object({
	VITE_ADMIN_API_URL: z.string().url().default('http://localhost:18090'),
	VITE_AUTH_ENABLED: z.enum(['true', 'false']).default('false'),
	VITE_KEYCLOAK_URL: optionalUrl,
	VITE_KEYCLOAK_REALM: optionalString,
	VITE_KEYCLOAK_CLIENT_ID: z.string().min(1).default('tisit-admin-web'),
})

export const parseApplicationEnv = (input: unknown) => {
	const result = schema.safeParse(input)
	if (!result.success) {
		throw new Error(`Invalid application environment: ${result.error.message}`)
	}
	const values = result.data
	const authEnabled = values.VITE_AUTH_ENABLED === 'true'
	if (authEnabled && (!values.VITE_KEYCLOAK_URL || !values.VITE_KEYCLOAK_REALM)) {
		throw new Error(
			'VITE_KEYCLOAK_URL and VITE_KEYCLOAK_REALM are required when authentication is enabled',
		)
	}
	return {
		adminApiUrl: values.VITE_ADMIN_API_URL.replace(/\/$/, ''),
		authEnabled,
		keycloakUrl: values.VITE_KEYCLOAK_URL,
		keycloakRealm: values.VITE_KEYCLOAK_REALM,
		keycloakClientId: values.VITE_KEYCLOAK_CLIENT_ID,
	}
}

export const env = parseApplicationEnv(import.meta.env)
